module.exports = __webpack_public_path__ + "static/media/investments.8ac01f55.svg";